import React from "react";
import { OptionContainer, OptionContent, OptionLabel } from "../../../styles";
import PeoplePicker from "../../../../../../../components/ui/people-picker/PeoplePicker";
import { usePeopleStore } from "../../../../../../../stores/use-people-store";
import { useTranslation } from "react-i18next";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { usePeople } from "../../../../../../../features/people/usePeople";
import ReorderableUser from "./ReorderableUser";

function Manual() {
  const { t } = useTranslation();
  const { data, selectedTab, updateConfigTab } = usePeopleStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const userQueries = usePeople(
    data.config?.tabs[selectedTab]?.manuallyPicked,
    { fetchWithCosmosData: false }
  );

  const selectedPeople = data.config.tabs[selectedTab].manuallyPicked;

  const onSelect = (selectedUser) => {
    if (
      !selectedUser ||
      selectedPeople.some((user) => selectedUser.id === user.accountId)
    ) {
      return;
    }

    const currentLastPicked =
      selectedPeople.length > 0
        ? selectedPeople[selectedPeople.length - 1]
        : null;

    const position = currentLastPicked ? currentLastPicked.position + 1 : 1;

    const newContent = {
      id: crypto.randomUUID(),
      position,
      accountId: selectedUser.id,
    };

    updateConfigTab({
      value: {
        manuallyPicked: [...selectedPeople, newContent],
      },
    });
  };

  const removeUser = (id) => {
    const newManuallyPicked = data.config.tabs[
      selectedTab
    ].manuallyPicked.filter((user) => user.id !== id);
    updateConfigTab({
      value: {
        manuallyPicked: newManuallyPicked,
      },
    });
  };

  const resetOrder = (list) => {
    const resetList = list.map((c, index) => {
      const slide = c;
      slide.order = index + 1;
      return slide;
    });
    return resetList;
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return resetOrder(result);
  };

  const reorderPanels = (sourceId, targetId) => {
    if (sourceId === targetId) {
      return;
    }
    const copyOfUsers = [...userQueries.map(({ data }) => data)];
    const sourceIndex = sourceId;
    const targetIndex = targetId;
    const items = reorder(copyOfUsers, sourceIndex, targetIndex);

    updateConfigTab({
      value: {
        manuallyPicked: items,
      },
    });
  };

  return (
    <>
      <OptionContainer direction="column">
        <OptionLabel>{t("people")}</OptionLabel>
        <OptionContent full>
          <PeoplePicker
            key={selectedPeople.map(({ id }) => id).join("-")}
            selectedPeople={selectedPeople}
            onSelect={(user) => onSelect(user)}
          />
        </OptionContent>
      </OptionContainer>

      <DndProvider backend={HTML5Backend}>
        <OptionContainer direction="column">
          {userQueries.map(({ data }, _idx) => (
            <ReorderableUser
              user={data || {}}
              index={_idx}
              reorderPanels={reorderPanels}
              removeUser={removeUser}
            />
          ))}
        </OptionContainer>
      </DndProvider>
    </>
  );
}

export default Manual;
